<template>
  <div class="pins">
    <van-empty
      class="custom-image"
      :image="img"
      description="暂时没有内容"
    />
    <dibu class="dibu"></dibu>
  </div>
</template>

<script>
import { } from "@/api/home";
import { Toast } from "vant";
import dibu from "@/components/index/di";
export default {
  data() {
    return {
      img: require("../../assets/img/kong.png"),
    };
  },
  watch: {
    
  },
  components: { dibu },
  methods: {
    
  },
  mounted() {
    
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/index/public.vue